import React, { useEffect, useState } from "react";
import {
  Button,
  Typography,
  Form,
  Select,
  Input,
  Tag,
  notification,
} from "antd";
import { del, get } from "../../../api/axios";
import { Link } from "react-router-dom";
import { Popconfirm } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { checkPermission } from "../../control-sections/auth/ProtectedRoutes";
import { onChangeTableHelper } from "../../control-sections/helper/TableHelpers";
import TableComponent from "../../control-sections/helper/TableComponent";

const Listings = () => {
  const { Title } = Typography;
  const [form] = Form.useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const [total, setTotal] = useState(1);

  const [filterData, setFilterData] = useState({
    filter_key: "",
    filter_value: "",
  });

  const [sorter, setSorter] = useState({
    sort_by: "",
    order: "",
  });

  const columns = [
    {
      title: " Id",
      dataIndex: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Title",
      dataIndex: "title",
      sorter: (a, b) => a.title - b.title,
    },
    {
      title: "Property Type",
      dataIndex: "property_type",
      sorter: (a, b) => a.property_type - b.property_type,
    },
    {
      title: "Listing Type",
      dataIndex: "listing_type",
      sorter: (a, b) => a.listing_type - b.listing_type,
    },
    {
      title: "Location",
      dataIndex: "location",
      sorter: (a, b) => a.location - b.location,
    },
    {
      title: "Active",
      render: ({ is_active }) => (
        <>
          <Tag color={`${is_active == 1 ? "success" : "error"}`}>
            {is_active == 1 ? "Active" : "Inactive"}
          </Tag>
        </>
      ),
    },
    {
      title: "Status",
      render: ({ approval_status }) => (
        <>
          <Tag color={`${approval_status == "approved" ? "success" : approval_status == "rejected" ? "error" : "warning"}`}>
            {approval_status == "approved" ? "Approved" : approval_status =="rejected" ? "Rejected" : "Pending"}
          </Tag>
        </>
      ),
    },
  ];

  if (
    checkPermission("update-seller-listings") ||
    checkPermission("delete-seller-listings")
  ) {
    columns.push({
      title: "Actions",
      dataIndex: "id",
      render: (id, record) => (
        <>
          {record.approval_status == "approved" ? (
            <div>
              {checkPermission("update-seller-listings") && (
                <Button className="btn btn-outline-warning btn-edit btn-sm p-0 me-3">
                  <Link
                    className="color-inherit text-decoration-none py-1 px-2 d-block"
                    to={`/listings/edit/${id}`}
                  >
                    <EditOutlined />
                  </Link>
                </Button>
              )}

              {checkPermission("delete-seller-listings") && (
                <Popconfirm
                  title="Delete item"
                  description="Are you sure you want to delete this item?"
                  onConfirm={() => confirm(id)}
                  onCancel={cancel}
                  okText="OK"
                  cancelText="Cancel"
                >
                  <Button danger className="flex-center d-inline-flex">
                    <DeleteOutlined />
                  </Button>
                </Popconfirm>
              )}
            </div>
          ) : (
            <div>
              {checkPermission("review-listing") && (
                <Button className="btn btn-outline-secondary btn-edit btn-sm p-0 me-3">
                  <Link
                    className="color-inherit text-decoration-none py-1 px-2 d-block"
                    to={`/listings/change-status/${id}`}
                  >
                    Review
                  </Link>
                </Button>
              )}
            </div>
          )}
        </>
      ),
    });
  }

  useEffect(() => {
    get("listings?page=1&limit=50").then((res) => {
      setData(res.data.data);
      setTotal(res.data.meta.total);
      setLoading(false);
    });
  }, []);

  const handleDelete = (id) => {
    del(`listings/${id}`).catch((err) => {
      notification.error({
        message: "Error!",
        description: err.response.data.message,
      });
      setLoading(false);
    });
    let dateFilter = data.filter((item) => item.id !== id);
    setData(dateFilter);
  };

  const confirm = (id) => {
    handleDelete(id);
    notification.success({ message: "It was successful" });
  };

  const cancel = (e) => {
    notification.info({ message: "The order has been cancelled" });
  };

  const handleFilterKey = (e) => {
    setFilterData({ ...filterData, filter_key: e });
  };

  const handleFilterVal = (e) => {
    setFilterData({ ...filterData, [e.target.id]: e.target.value });
  };

  const onFilter = (values) => {
    setLoadingSearch(true);

    get(
      `listings?filter_key=${filterData.filter_key}&filter_value=${
        filterData.filter_value
      }${
        sorter.sort_by !== "" && sorter.sort_by !== undefined
          ? `&sort_by=${sorter.sort_by}`
          : ""
      }${sorter.order !== "" ? `&order=${sorter.order}` : ""}`
    )
      .then((res) => {
        setData(res.data.data);
        setTotal(res.data.meta.total);
        setLoadingSearch(false);
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response.data.message,
        });
        setLoadingSearch(false);
      });
  };

  const clearSearch = () => {
    form.resetFields();
    setFilterData({
      filter_key: "",
      filter_value: "",
    });
    get("listings?page=1&limit=50").then((res) => {
      setData(res.data.data);
      setTotal(res.data.meta.total);
    });
  };

  const onChangeTable = (pagination, filters, sorter) => {
    setLoading(true);
    setSorter({
      ...sorter,
      sort_by: sorter.field,
      order: sorter.order == "descend" ? "desc" : "asc",
    });

    onChangeTableHelper("listings", pagination, filterData, sorter)
      .then((res) => {
        setData(res.data.data);
        setTotal(res.data.meta.total);
        setLoading(false);
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response.data.message,
        });
        setLoading(false);
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <Title level={2} className="text-main mb-2">
                Listings
              </Title>
            </div>
            {checkPermission("create-seller-listings") ? (
              <div className="col-lg-3 offset-lg-3 text-end">
                <Button type="primary" className="p-0" size="large">
                  <Link
                    className="text-decoration-none h-100 flex-center py-2 px-4"
                    to="/listings/add"
                  >
                    Add Listings
                  </Link>
                </Button>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      <div className="grid-margin stretch-card wrapper-content">
        <Form onFinish={onFilter} layout="vertical" form={form}>
          <div className="row">
            <div className="col-12 col-lg-4">
              <Form.Item
                label="Search By"
                name="filter_key"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Select
                  className="w-100"
                  showSearch
                  placeholder="select test "
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={handleFilterKey}
                  options={[
                    {
                      value: "property_type",
                      label: "Property Type",
                    },
                    {
                      value: "price",
                      label: "Price",
                    },
                    {
                      value: "listing_type",
                      label: "Listing Type",
                    },
                    {
                      value: "location",
                      label: "Location",
                    },
                    {
                      value: "title",
                      label: "Title",
                    },
                    {
                      value: "area",
                      label: "Area",
                    },
                    {
                      value: "floor",
                      label: "Floors",
                    },
                    {
                      value: "rooms",
                      label: "Rooms",
                    },
                    {
                      value: "bathrooms",
                      label: "Bathrooms",
                    },
                    {
                      value: "bedrooms",
                      label: "Bedrooms",
                    },
                    {
                      value: "is_furnished",
                      label: "Is Furnished",
                    },
                  ]}
                />
              </Form.Item>
            </div>
            <div className="col-12 col-lg-6">
              <Form.Item
                label="Search"
                name="filter_value"
                onChange={handleFilterVal}
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input placeholder="Type to search..." />
              </Form.Item>
            </div>
            <div className="col-12 col-lg-2 d-flex align-items-end">
              <Form.Item className="w-100">
                <div className="row">
                  <div className="col-8">
                    <Button
                      block
                      loading={loadingSearch}
                      type="primary"
                      htmlType="submit"
                    >
                      {loadingSearch ? "Searching" : "Search"}
                    </Button>
                  </div>
                  <div className="col-4">
                    <Button
                      onClick={clearSearch}
                      className="flex-center"
                      danger
                      type="primary"
                    >
                      <DeleteOutlined />
                    </Button>
                  </div>
                </div>
              </Form.Item>
            </div>
          </div>
        </Form>
        <TableComponent
          onChangeTable={onChangeTable}
          loading={loading}
          columns={columns}
          data={data}
          total={total}
        />
      </div>
    </div>
  );
};

export default Listings;
